import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL,
  timeout: 15000,
  withCredentials: true,
})

export default instance
